var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg076Department(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "32px",
    height: "32px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#888e02",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(10.66667,10.66667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.5,2c-1.93,0 -3.5,1.57 -3.5,3.5c0,1.21187 0.62013,2.28172 1.55859,2.91016c-1.48175,0.6343 -2.55859,1.95937 -2.55859,3.58984h2c0,-1.02654 1.03018,-2 2.5,-2c1.46982,0 2.5,0.97346 2.5,2h2c0,-1.63047 -1.07684,-2.95555 -2.55859,-3.58984c0.93846,-0.62843 1.55859,-1.69828 1.55859,-2.91016c0,-1.93 -1.57,-3.5 -3.5,-3.5zM12,2v2c3.76107,0 6.89954,2.58501 7.76367,6.06641l1.94141,-0.48242c-1.08187,-4.3586 -5.02615,-7.58398 -9.70508,-7.58398zM5.5,4c0.827,0 1.5,0.673 1.5,1.5c0,0.827 -0.673,1.5 -1.5,1.5c-0.827,0 -1.5,-0.673 -1.5,-1.5c0,-0.827 0.673,-1.5 1.5,-1.5zM18.5,12c-1.93,0 -3.5,1.57 -3.5,3.5c0,1.21187 0.62013,2.28172 1.55859,2.91016c-1.48175,0.6343 -2.55859,1.95937 -2.55859,3.58984h2c0,-1.02654 1.03018,-2 2.5,-2c1.46982,0 2.5,0.97346 2.5,2h2c0,-1.63047 -1.07684,-2.95555 -2.55859,-3.58984c0.93846,-0.62843 1.55859,-1.69828 1.55859,-2.91016c0,-1.93 -1.57,-3.5 -3.5,-3.5zM18.5,14c0.827,0 1.5,0.673 1.5,1.5c0,0.827 -0.673,1.5 -1.5,1.5c-0.827,0 -1.5,-0.673 -1.5,-1.5c0,-0.827 0.673,-1.5 1.5,-1.5zM4.36523,14.40039l-1.90625,0.59961c1.27652,4.05972 5.07386,7 9.54102,7v-2c-3.59084,0 -6.61528,-2.35733 -7.63477,-5.59961z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg076Department);
export default __webpack_public_path__ + "static/media/076 Department.0892f89da5c972a064620df18a66eace.svg";
export { ForwardRef as ReactComponent };